<template>
  <v-dialog
    class="dialog"
    v-model="watchedUserVisible"
    :modal-append-to-body="false"
    :before-close="close"
    width="400px"
    @click:outside="close"
  >
    <v-row
      no-gutters
      class="pt-2"
      style="background-color: #21343b; overflow-y: auto; overflow-x: hidden; max-height: 750px"
    >
      <v-expansion-panels dark flat v-model="panel" multiple>
        <v-expansion-panel v-if="watchedUser.length > 0">
          <v-expansion-panel-header color="#21343b">
            <v-col cols="12" class="px-3">
              <span class="txt-section-title ml-2">{{ $t('viewers') }}</span>
            </v-col>
          </v-expansion-panel-header>
          <v-expansion-panel-content color="#21343b">
            <v-col cols="12" style="padding: 0">
              <v-card class="mx-auto" max-width="400" elevation="0" dark>
                <v-list style="background-color: #21343b; border-color: #21343b; padding: 0px">
                  <v-list-item v-for="user in watchedUser" :key="user.userId">
                    <v-list-item-icon>
                      <v-avatar
                        :color="user.userDisplayName | iconBackground"
                        class="logo"
                        round
                        size="35"
                        style="cursor: pointer"
                      >
                        <span class="white--text text-h6 cent" v-if="!user.userPicture">
                          {{ user.userDisplayName || user.userFullName | iconFilter }}
                        </span>
                        <v-img :src="user.userPicture" v-else />
                      </v-avatar>
                      <v-icon v-if="user.userId === mtInfo.mtOrganizerUid" color="#ffc107" class="crown-icon">
                        mdi-crown
                      </v-icon>
                    </v-list-item-icon>

                    <v-list-item-content style="flex-flow: nowrap">
                      <v-list-item-title class="dialog-user-name">
                        {{ user.userDisplayName || user.userFullName }}
                      </v-list-item-title>
                      <v-list-item-subtitle style="text-align: right; font-size: 12px">
                        {{ $day.duration($day().diff(user.clipWatchedAt)).humanize() + ' ago' }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                  <v-list-item v-for="user in anonymousUser" :key="user.userId">
                    <v-list-item-icon>
                      <v-avatar
                        :color="user.userDisplayName | iconBackground"
                        class="logo"
                        round
                        size="35"
                        style="cursor: pointer"
                      >
                        <span class="white--text text-h6 cent">
                          {{ user.userDisplayName | iconFilter }}
                        </span>
                      </v-avatar>
                    </v-list-item-icon>

                    <v-list-item-content style="flex-flow: nowrap">
                      <v-list-item-title class="dialog-user-name">
                        <span>Anonymous</span>
                      </v-list-item-title>
                      <v-list-item-subtitle style="text-align: right; font-size: 12px">
                        {{ $day.duration($day().diff(user.clipWatchedAt)).humanize() + ' ago' }}
                      </v-list-item-subtitle>
                    </v-list-item-content>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel v-if="unWatchedUser.length > 0">
          <v-expansion-panel-header color="#21343b" style="padding-top: 0">
            <v-col cols="12" class="px-3">
              <span class="txt-section-title ml-2">{{ 'Who haven’t viewed this clip yet' }}</span>
            </v-col>
          </v-expansion-panel-header>

          <v-expansion-panel-content color="#21343b">
            <v-col cols="12" style="padding: 0">
              <v-card class="mx-auto" max-width="400" elevation="0" dark>
                <v-list style="background-color: #21343b; border-color: #21343b">
                  <!-- <v-list-item-group color="#3ed297"> -->
                  <v-list-item v-for="user in unWatchedUser" :key="user.userId" disabled>
                    <template v-slot:default="{}">
                      <v-list-item-icon>
                        <v-avatar
                          :color="user.userDisplayName | iconBackground"
                          class="logo"
                          round
                          size="35"
                          style="cursor: pointer"
                        >
                          <span class="white--text text-h6 cent" v-if="!user.userPicture">
                            {{ user.userDisplayName || user.userFullName | iconFilter }}
                          </span>
                          <v-img :src="user.userPicture" v-else />
                        </v-avatar>
                        <v-icon v-if="user.userId === mtInfo.mtOrganizerUid" color="#ffc107" class="crown-icon">
                          mdi-crown
                        </v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title class="dialog-user-name">
                          {{ user.userDisplayName || user.userFullName }}
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action v-if="isClipUploader" style="pointer-events: all !important">
                        <v-btn outlined rounded height="30" width="75" color="#27cd8b">
                          <span style="color: #aaa" @click="sendRemind($event, user.userEmail)" :loading="isLoading">
                            {{ 'Remind' }}
                          </span>
                        </v-btn>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>

        <v-expansion-panel v-if="unWatchedOther.length > 0">
          <v-expansion-panel-header color="#21343b" style="padding-top: 0">
            <v-col cols="12" class="px-3">
              <span class="txt-section-title ml-2">{{ 'Other' }}</span>
            </v-col>
          </v-expansion-panel-header>

          <v-expansion-panel-content color="#21343b">
            <v-col cols="12" style="padding: 0">
              <v-card class="mx-auto" max-width="400" elevation="0" dark>
                <v-list style="background-color: #21343b; border-color: #21343b">
                  <!-- <v-list-item-group color="#3ed297"> -->
                  <v-list-item v-for="user in unWatchedOther" :key="user.userId" disabled>
                    <template v-slot:default="{}">
                      <v-list-item-icon>
                        <v-avatar
                          :color="user.userDisplayName | iconBackground"
                          class="logo"
                          round
                          size="35"
                          style="cursor: pointer"
                        >
                          <span class="white--text text-h6 cent" v-if="!user.userPicture">
                            {{ user.userDisplayName || user.userFullName | iconFilter }}
                          </span>
                          <v-img :src="user.userPicture" v-else />
                        </v-avatar>
                        <v-icon v-if="user.userId === mtInfo.mtOrganizerUid" color="#ffc107" class="crown-icon">
                          mdi-crown
                        </v-icon>
                      </v-list-item-icon>

                      <v-list-item-content>
                        <v-list-item-title class="dialog-user-name">
                          {{ user.userDisplayName || user.userFullName }}
                        </v-list-item-title>
                      </v-list-item-content>

                      <v-list-item-action v-if="isClipUploader" style="pointer-events: all !important">
                        <v-btn outlined rounded height="30" width="75" color="#27cd8b">
                          <span style="color: #aaa" @click="sendRemind($event, user.userEmail)" :loading="isLoading">
                            {{ 'Remind' }}
                          </span>
                        </v-btn>
                      </v-list-item-action>
                    </template>
                  </v-list-item>
                </v-list>
              </v-card>
            </v-col>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </v-row>
    <v-row no-gutters class="btn-bottom px-8 py-5" style="background-color: #21343b">
      <v-btn width="100%" height="40" elevation="0" color="#869399" @click="close">{{ $t('done') }}</v-btn>
    </v-row>
  </v-dialog>
</template>

<script>
import { mapGetters } from 'vuex'
import { sendRemind } from '@/services/clipApi'
export default {
  name: 'WatchedUserDialog',
  props: {
    watchedUserVisible: Boolean,
    watchedUser: Array,
    unWatchedUser: Array,
    unWatchedOther: Array,
    anonymousUser: Array,
  },
  data() {
    return {
      panel: [0, 1, 2],
      isLoading: false,
    }
  },
  mounted() {
    document.addEventListener('keydown', this.keyEvent)
  },
  beforeDestroy() {
    document.removeEventListener('keydown', this.keyEvent)
  },
  methods: {
    async sendRemind(event, userEmail) {
      try {
        event.target.parentNode.parentNode.setAttribute('disabled', 'disabled')
        event.target.parentNode.parentNode.classList.add('v-btn--disabled')
        event.target.innerHTML = 'Sent'
        this.isLoading = true
        await sendRemind(this, this.selectedWsInfo['wsDomain'], this.mtInfo.mtId, this.currentClip.clipId, [userEmail])
      } catch (error) {
        console.log(error)
        event.target.parentNode.parentNode.removeAttribute('disabled')
        event.target.parentNode.parentNode.classList.remove('v-btn--disabled')
        event.target.innerHTML = 'Remind'
      } finally {
        this.isLoading = false
      }
    },
    close() {
      this.$emit('close')
    },
    keyEvent(e) {
      // W 누르면 다이얼로그 닫기
      if (
        !(e.target instanceof HTMLTextAreaElement) &&
        !(e.target instanceof HTMLInputElement) &&
        e.target.contentEditable !== 'true'
      ) {
        if (!e.ctrlKey && !e.metaKey && e.keyCode == 87) {
          this.$emit('close')
          e.preventDefault()
        }
      }
    },
  },
  computed: {
    ...mapGetters(['selectedWsInfo', 'userInfo', 'currentClip']),
    mtInfo() {
      return this.$store.getters.currentMt
    },
    isClipUploader() {
      let clipUploader = this.currentClip.clipUploader
      if (clipUploader && this.userInfo) {
        return clipUploader.userId === this.userInfo.userId
      }
      return false
    },
  },
}
</script>

<style scoped>
.txt-section-title {
  font-weight: 700;
  font-size: 18px;
  color: white;
  align-self: center;
}
.txt-section-subtitle {
  font-weight: 500;
  font-size: 16px;
  color: #ddd;
  align-self: center;
}
.v-dialog__content >>> .v-dialog {
  border-radius: 24px;
  overflow: hidden;
}
.dialog >>> .el-dialog {
  background: transparent;
}
.dialog >>> .el-dialog__body {
  background: #21343b !important;
  border-bottom-left-radius: 10px;
  border-bottom-right-radius: 10px;
}

.dialog >>> .el-dialog__header {
  border-top-left-radius: 10px;
  border-top-right-radius: 10px;
  padding-left: 32px;
  background: #21343b !important;
}
.dialog >>> .el-dialog__title {
  color: white;
  font-weight: bold;
}
.dialog >>> .el-dialog__close {
  margin-right: 10px;
  background: #21343b !important;
}

.dialog-user-name {
  font-weight: 600;
  font-size: 14px;
  line-height: 18px;
}

.crown-icon {
  position: absolute;
  font-size: 20px;
  margin-left: 7px;
  bottom: calc(50% + 7px);
}
.logo {
  position: relative;
  border: 2px solid #21343b !important;
  margin-right: -11px;
  overflow: visible;
  cursor: default !important;
  z-index: 1;
}
.btn-bottom >>> .v-btn * {
  font-size: 14px;
  color: white;
  letter-spacing: 0;
  text-transform: none;
  font-weight: bold;
}
.v-list-item__icon {
  margin: 10px 0;
}
.v-expansion-panel--active > .v-expansion-panel-header {
  padding: 16px 24px 10px 24px;
}
</style>
